import { useContext } from 'react'
import { PlayerContext } from '../contexts'

export const usePlayerContext = () => useContext(PlayerContext)
